// Services Section - SEO optimized with H2/H3 - Mobile Optimized
const ServicesSection = () => {
  const services = [
    {
      icon: "fa-plane-arrival",
      title: "Traslados Aeropuerto Málaga",
      description: "Servicio premium de recogida y traslado al Aeropuerto de Málaga-Costa del Sol. Monitorización de vuelos incluida."
    },
    {
      icon: "fa-clock",
      title: "Servicio VTC por Horas",
      description: "Disposición de chófer y vehículo de lujo por el tiempo que necesite. Desde 60€/hora. Ideal para reuniones y eventos."
    },
    {
      icon: "fa-route",
      title: "Tours Exclusivos Costa del Sol",
      description: "Descubra Marbella, Ronda, Granada o Sevilla con nuestros tours personalizados en vehículos de lujo."
    },
    {
      icon: "fa-briefcase",
      title: "Transporte Corporativo",
      description: "Soluciones de transporte ejecutivo para empresas. Facturación mensual y tarifas especiales para corporativos."
    }
  ];

  return (
    <section id="servicios" className="py-16 sm:py-24 px-4 bg-[#0a0a14]" data-testid="services-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 sm:mb-16">
          <p className="section-subtitle tracking-[4px]">Nuestros Servicios</p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl tracking-wide" style={{ fontFamily: "'Cinzel', serif" }}>
            Experiencias <span className="gradient-text">Premium</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-8">
          {services.map((service, idx) => (
            <article
              key={idx}
              className="luxury-card p-5 sm:p-8 group"
              data-testid={`service-card-${idx}`}
            >
              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-[#c9a962]/10 flex items-center justify-center mb-4 sm:mb-6 group-hover:bg-[#c9a962]/20 transition-colors">
                <i className={`fas ${service.icon} text-[#c9a962] text-xl sm:text-2xl`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-semibold mb-2 sm:mb-4" style={{ fontFamily: "'Cinzel', serif" }}>
                {service.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-400 leading-relaxed">{service.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
